var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React, { Fragment } from 'react';
import styled, { css } from 'styled-components';
import { getFont } from '@finect/tabular-utils/getFont';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
import { Briefcase } from '@finect/tabular-icons/briefcase';
import { TrendingUp } from '@finect/tabular-icons/trendingUp';
import { User } from '@finect/tabular-icons/user';
import { MessageSquare } from '@finect/tabular-icons/messageSquare';
import { File } from '@finect/tabular-icons/file';
import { FileText } from '@finect/tabular-icons/fileText';
import { List } from '@finect/tabular-icons/list';
import { Tag as HtmlTag } from '@finect/tabular-components/Tags';
import { Tag } from '@finect/tabular-icons/tag';
import { ShoppingCart } from '@finect/tabular-icons/shoppingCart';
import { Follow } from '@finect/tabular-components/Follow';
import { getProductTypeById, productTypes } from '@finect/front-resources/Products';
import { Link, matchPath } from 'react-router-dom';
const Actions = styled.div.withConfig({
  displayName: "SearchResultItem__Actions",
  componentId: "sc-wz5u4a-0"
})(["", ";"], maxMediaQueries.phablet(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    flex: 1;\n    margin-bottom: 6px;\n    text-align: right;\n    white-space: nowrap;\n  "]))));
const Contact = styled.span.withConfig({
  displayName: "SearchResultItem__Contact",
  componentId: "sc-wz5u4a-1"
})(["display:inline-block;position:relative;padding-right:12px;margin-left:12px;margin-right:3px;", ";font-weight:500;color:", ";&:after{position:absolute;top:-3px;bottom:-3px;right:0;border-right:1px solid ", ";content:'';}"], getFont(-1), _ref => {
  let {
    theme
  } = _ref;
  return theme.linkColor;
}, _ref2 => {
  let {
    theme
  } = _ref2;
  return theme.colors.uiM;
});
const selectedStyles = css(["background-color:", ";"], _ref3 => {
  let {
    theme
  } = _ref3;
  return theme.colors.uiLL;
});
const ResultItem = styled.a.withConfig({
  displayName: "SearchResultItem__ResultItem",
  componentId: "sc-wz5u4a-2"
})(["display:block;padding:12px 12px 15px;border-bottom:1px solid ", ";color:", ";svg{position:relative;left:-2px;flex-shrink:0;margin-right:12px;stroke:", ";}p{position:relative;top:1px;margin-right:12px;", ";}small{display:block;position:relative;top:3px;left:32px;", ";font-weight:500;font-variant:small-caps;color:", ";}&:last-child{border-radius:", ";}", ";", ";", ";"], _ref4 => {
  let {
    theme
  } = _ref4;
  return theme.borderColor;
}, _ref5 => {
  let {
    theme
  } = _ref5;
  return theme.colors.font;
}, _ref6 => {
  let {
    theme
  } = _ref6;
  return theme.defaultIconColor;
}, getFont(0, 'xcompact'), getFont(-1, 'compact'), _ref7 => {
  let {
    theme
  } = _ref7;
  return theme.colors.fontLL;
}, _ref8 => {
  let {
    theme
  } = _ref8;
  return "0 0 ".concat(theme.borderRadius, " ").concat(theme.borderRadius);
}, _ref9 => {
  let {
    isSelected
  } = _ref9;
  return isSelected && selectedStyles;
}, maxMediaQueries.phablet(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    flex-wrap: wrap;\n    padding: 12px 12px 9px;\n\n    svg {\n      left: 0;\n    }\n  "]))), maxMediaQueries.phone(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    padding-left: 15px;\n    padding-right: 15px;\n  "]))));
const ResultItemInfo = styled.div.withConfig({
  displayName: "SearchResultItem__ResultItemInfo",
  componentId: "sc-wz5u4a-3"
})(["display:flex;position:relative;align-items:center;justify-content:space-between;", ";"], maxMediaQueries.phablet(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    flex-wrap: wrap;\n  "]))));
const ResultItemName = styled.div.withConfig({
  displayName: "SearchResultItem__ResultItemName",
  componentId: "sc-wz5u4a-4"
})(["display:flex;align-items:center;min-height:27px;", ";"], maxMediaQueries.phablet(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    margin-bottom: 6px;\n  "]))));
const LogoGroup = styled.img.withConfig({
  displayName: "SearchResultItem__LogoGroup",
  componentId: "sc-wz5u4a-5"
})(["width:20px;height:20px;border:1px solid #666;margin-right:12px;"]);
const cleanType = resultType => {
  if (resultType.includes('article')) return 'article';
  if (resultType.includes('group')) return 'company';
  return resultType;
};
const displayActions = (resultType, allowMessaging) => {
  const cleanedType = cleanType(resultType);
  const followTypes = ['fund', 'plan', 'sicav', 'etf', 'equity', 'stock', 'company', 'user', 'tag'];
  const contactTypes = ['company', 'user'];
  const actions = [];
  followTypes.includes(cleanedType) && actions.push('follow');
  contactTypes.includes(cleanedType) && allowMessaging && actions.push('contact');
  return actions;
};
const displayIcon = (resultType, entity) => {
  const cleanedType = cleanType(resultType);
  const props = {
    size: '20',
    strokeWidth: '1.8'
  };
  switch (cleanedType) {
    case 'fund':
    case 'plan':
    case 'sicav':
    case 'etf':
    case 'equity':
    case 'stock':
    case 'index':
    case 'exchange':
    case 'product':
      return React.createElement(TrendingUp, props);
    case 'organization':
      return React.createElement(List, props);
    case 'company':
      return React.createElement(Briefcase, props);
    case 'user':
      return React.createElement(User, props);
    case 'article':
      return React.createElement(FileText, props);
    case 'question':
      return React.createElement(MessageSquare, props);
    case 'tag':
      return entity && entity.window ? React.createElement(ShoppingCart, props) : React.createElement(Tag, props);
    case 'page':
    default:
      return React.createElement(File, props);
  }
};
const productsSPAPaths = Object.values(productTypes).map(_ref10 => {
  let {
    slug
  } = _ref10;
  return "/".concat(slug);
});
const SPA_PATHS = [{
  app: 'front-products',
  test: url => url.startsWith('/fondos-inversion')
}, {
  app: 'front-products',
  test: url => url.startsWith('/planes-pensiones')
}, {
  app: 'front-products',
  test: url => productsSPAPaths.map(path => url.startsWith(path)).some(item => Boolean(item))
}, {
  app: 'front-products',
  test: url => matchPath(url, {
    exact: true,
    path: '/usuario/:user/articulos/:article'
  })
}, {
  app: 'front-products',
  test: url => matchPath(url, {
    exact: true,
    path: '/grupos/:organization/articulos/:article'
  })
}, {
  app: 'front-products',
  test: url => url.startsWith('/invertir')
}, {
  app: 'front-products',
  test: url => url.startsWith('/temas')
}, {
  app: 'front-questions',
  test: url => url.startsWith('/preguntas')
}, {
  app: 'front-advisers',
  test: url => url.startsWith('/asesores')
}];
const isSPALink = (finectApp, url) => SPA_PATHS.some(_ref11 => {
  let {
    app,
    test
  } = _ref11;
  return app === finectApp && test(url);
});
const names = {
  fund: 'Fondo',
  organization: 'Gestora',
  user: 'Usuario',
  company: 'Página en finect',
  article: 'Artículo',
  question: 'Pregunta',
  page: 'Página',
  stock: 'Acción',
  index: 'Índice',
  exchange: 'Mercado',
  tag: 'Sección de finect',
  product: 'Producto',
  storefront: 'Escaparate'
};
const getLabel = (type, entity) => {
  if (type === 'product') {
    const productType = getProductTypeById(entity.subtype);
    return productType ? productType.singular : names.product;
  }
  if (type === 'tag') {
    return entity.window ? names.storefront : names[cleanType(type)];
  }
  return names[cleanType(type)] || type;
};
export const SearchResultItem = _ref12 => {
  let {
    finectApp,
    result,
    following,
    isSelected,
    index,
    hideResults,
    setSelected,
    subscribe,
    unsubscribe
  } = _ref12;
  const handleMouseEnter = () => {
    setSelected(index);
  };
  const handleMouseDown = event => {
    event.preventDefault();
  };
  const handleClick = () => {
    hideResults(true);
  };
  const sendMessage = event => {
    event.preventDefault();
    event.stopPropagation();
    location.href = "https://".concat(process.env.FINECT_BASEURL || 'www.finect.com', "/mensajes/nuevo?members=").concat(result.id);
  };
  const followEntity = event => {
    event.preventDefault();
    event.stopPropagation();
    const cleanedType = cleanType(result.type);
    return following ? unsubscribe(cleanedType, result.id.toUpperCase()) : subscribe(cleanedType, result.id.toUpperCase());
  };
  const {
    title,
    type,
    url,
    entity
  } = result;
  const actions = displayActions(type, type === 'user' || type === 'group' && entity.feature_set & 4);
  const cleanSubtype = entity && entity.hasOwnProperty('subtype') ? entity.subtype : type;
  const productType = getProductTypeById(cleanSubtype);
  const linkUrl = productType && ['content'].includes(productType.category) ? "/".concat(productType.slug, "/").concat(url) : url;
  const linkProps = isSPALink(finectApp, linkUrl) && !linkUrl.includes('finect.com') ? {
    to: linkUrl,
    as: Link
  } : {
    href: linkUrl
  };
  return React.createElement(ResultItem, _extends({
    "data-fi-event": "omninav-searchResult",
    isSelected: isSelected,
    onMouseEnter: handleMouseEnter,
    onMouseDown: handleMouseDown,
    onClick: handleClick
  }, linkProps), React.createElement("small", null, getLabel(type, entity)), React.createElement(ResultItemInfo, null, React.createElement(ResultItemName, null, type === 'group' ? React.createElement(Fragment, null, entity.icon_url !== '/image/' ? React.createElement(LogoGroup, {
    src: "https://www.finect.com/".concat(entity.icon_url)
  }) : React.createElement(Fragment, null, displayIcon(type, entity)), React.createElement("p", null, title)) : null, type === 'user' ? React.createElement(Fragment, null, React.createElement(LogoGroup, {
    src: "https://www.finect.com/".concat(entity.icon_url)
  }), React.createElement("p", null, entity.first_name), React.createElement(HtmlTag, {
    small: true,
    color: "accent3"
  }, entity.adviser_at)) : null, type !== 'group' && type !== 'user' ? React.createElement(Fragment, null, displayIcon(type, entity), React.createElement("p", null, title)) : null), actions.length ? React.createElement(Actions, null, actions.includes('contact') && React.createElement(Contact, {
    onClick: sendMessage
  }, "Enviar mensaje"), actions.includes('follow') && React.createElement(Follow, {
    follow: followEntity,
    following: following,
    small: true
  })) : null));
};